import * as d3 from 'd3'

function scatterPlot(){

  // Data points that won't change
  let data = [];
  let title = '';
  let size = {
    width: 500,
    height: 500,
  };
  let fillColor = 'crimson';
  let timer;
  // Functions that can update the chart
  let drawChart

  function chart(selection){
    selection.each( function(){
      // build initial SVG here
      let quad = d3.select(this);  // 'this' was passed as a dom element
      let svg = quad.append('svg')
        .style('fill', fillColor);
      // tooltip div was created in App.js
      let tooltip = d3.select('#tooltip');
      // put the background here so we can make set opacity
      // background has to be a little bigger than chart area to handle points on the edge
      let bg = svg.append('g')
        .append('rect')
        .attr('fill', 'url("#bkgnd")')
        .attr('class', 'infographic')
        .attr('id', 'infographic')
        .attr('width', chartWidth + 20)
        .attr('height', chartHeight + 20);

      //set up the dimensions of the SVG
      let margin = { top: 45, right: 40, bottom: 60, left: 70 };
      let chartHeight = size.height - margin.top - margin.bottom;
      let chartWidth = size.width - margin.left - margin.right;

      // set up scales
      let xScale = d3.scaleLinear()
        .domain(d3.extent(data, (d) => { return d.rating }))
        .range([0, chartWidth]);

      let yScale = d3.scaleLinear()
        .domain(d3.extent(data, (d) => { return d.points }))
        .range([chartHeight, 0]);

      // set up a defs section for each logo.
      // this is to put a background logo on each "dot"
      let defs = svg.append('defs')
      data.forEach( function(d){
        defs.append('svg:pattern')
           .attr('id', d.team )
           .attr('patternContentUnits', 'objectBoundingBox')
           .attr('viewBox','0 0 1 1')
           .attr('preserveAspectRatio',"xMidYMid slice")
           .attr('width', '100%')
           .attr('height', '100%')
           .append('svg:image')
           .attr('xlink:href', 'icons/' + d.team + '_logo.svg')
           .attr('width', 1)
           .attr('height', 1)
           .attr('preserveAspectRatio',"xMidYMid slice")
      });
      // background image
      defs.append('svg:pattern')
         .attr('id', 'bkgnd' )
         .attr('patternContentUnits', 'objectBoundingBox')
         .attr('viewBox','0 0 1 1')
         .attr('preserveAspectRatio',"xMidYMid slice")
         .attr('width', '100%')
         .attr('height', '100%')
         .append('svg:image')
         .attr('xlink:href', 'icons/bkgnd.png')
         .attr('width', 1)
         .attr('height', 1)
         .attr('preserveAspectRatio',"xMidYMid slice")

      // here's the main group to which I will append all the chart components
      let groups = svg.append('g')

      // axes - move them to the center for our "quadrant" chart
      let xAxis = groups.append('g')
        .attr('class','axis')
        .attr('transform', 'translate( 0,' + chartHeight/2 + ')')
        .call(d3.axisBottom(xScale));

      let yAxis = groups.append('g')
        .attr('class', 'axis')
        .attr('transform', 'translate(' + chartWidth/2 + ', 0)')
        .call(d3.axisLeft(yScale));

      // labels for the axes
      let q1Label = groups.append('text')
        .attr('id', 'q1Label')
        .attr('transform', 'translate(0,0)')
        .text('The best offense is a good defense');
      let q2Label = groups.append('text')
        .attr('id', 'q2Label')
        .attr('transform', 'translate(0,0)')
        .text('Everything is Awesome!');
      let q3Label = groups.append('text')
        .attr('id', 'q3Label')
        .attr('transform', 'translate(0,0)')
        .text('Captains of the SS Titanic');
      let q4Label = groups.append('text')
        .attr('id', 'q4Label')
        .attr('transform', 'translate(0,0)')
        .text(`It's not me, it's you...`);

      // this function will get called when data changes or when size changes
      // it updates the infographic
      drawChart = function(){
        // resize chart, margins and scales
        chartHeight = size.height - margin.top - margin.bottom;
        chartWidth = size.width - margin.left - margin.right;

        // figure out size of labels, make sure chart is wide enough to display
        let q1Length = document.getElementById('q1Label').getComputedTextLength();
        let q2Length = document.getElementById('q2Label').getComputedTextLength();
        let q3Length = document.getElementById('q3Label').getComputedTextLength();
        let q4Length = document.getElementById('q4Label').getComputedTextLength();
        if (q1Length > chartWidth/2) {
          size.width = q1Length*2 + 40;
          chartHeight = size.height - margin.top - margin.bottom;
          chartWidth = size.width - margin.left - margin.right;
        }

        // transition svg, background, scales, axes and labels if window size changes
        svg.transition()
          .duration(600)
          .attr('width', size.width)
          .attr('height', size.height);

        bg.transition()
          .duration(600)
          .attr('transform', 'translate(' + (margin.left-20) + ',' + (margin.top-20) + ')')
          .attr('width', chartWidth + 40)
          .attr('height', chartHeight + 40);

        xScale.range([0,chartWidth]);
        xAxis.transition()
          .duration(600)
          .attr('transform', 'translate( 0,' + chartHeight/2 + ')')
          .call(d3.axisBottom(xScale));

        yScale.range([chartHeight, 0]);
        yAxis.transition()
          .duration(600)
          .attr('transform', 'translate(' + chartWidth/2 + ', 0)')
          .call(d3.axisLeft(yScale));

        groups.transition()
          .duration(600)
          .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

        q1Label.attr('transform', `translate( ${(((chartWidth/2)-q1Length)/2)}, -30)`)
        q2Label.attr('transform', `translate( ${((chartWidth/2)+((chartWidth/2)-q2Length)/2)}, -30)`)
        q3Label.attr('transform', `translate( ${(((chartWidth/2)-q3Length)/2)}, ${chartHeight+40})`)
        q4Label.attr('transform', `translate( ${((chartWidth/2)+((chartWidth/2)-q4Length)/2)},${chartHeight+40})`)

        // create update, enter, exit, transitions here
        // make sure to add a "key" function for data constancy
        let update = groups.selectAll('circle.dot')
          .data(data, (d)=>{return `${d.last}, ${d.first}`})

        // remove any dots that are no longer in data set
        update.exit()
          .style('opacity',0)
          .attr('width', 0)
          .attr('y',0)
          .attr('height', 0)
          .remove()

        // reposition any existing dots
        update.transition()
          .duration(600)
          .attr('cx', function(d){ return xScale(d.rating) })
          .attr('cy', function(d){ return yScale(d.points)})
          .attr('r', function(d) { return chartWidth > 400 ? 20 : 12 })

        // add new dots for each data point.
        // had some trouble accurately positioning the tooltip.  Possible IOS bug with getBoundingClientRect
        // attempting to fix it to the top-left corner
        update.enter()
          .append('circle')
          .attr('class', 'dot')
          .attr('cx', function(d){ return xScale(d.rating) })
          .attr('cy', function(d){ return yScale(d.points) })
          .attr('fill', function(d){ return( 'url("#' + d.team + '")')})
          .attr('r', function(d) { return chartWidth > 600 ? 20 : 12 })
          .on('mouseover', function(d){
            const dims = document.getElementById('infographic').getBoundingClientRect()
             tooltip.transition()
               .duration(200)
               .style("opacity", .8)
               .style("padding", "12px 8px")
               .style("top", `${dims.top}px`)
               .style("left", `${dims.left}px`)
             tooltip.html(`<b>${d.team}</b><hr/><b>#${d.number} - ${d.first} ${d.last}${d.complete? '' : '*'}</b><br/>Snaps: ${d.snaps} (${d.snapPct}%)<br/>Rating: ${d.rating}<br/>Point Diff: ${d.points}`)
          })
          .on('mouseout', function(d){
            tooltip.transition()
            .duration(200)
            .style("opacity", 0);
          })
          .on('touchstart', (d)=>{
            // for touch devices - show on touch, and hide after 5 seconds
            tooltip.transition()
            .duration(200)
            .style("opacity", .8)
            if (timer) { window.clearTimeout(timer) }
            timer = window.setTimeout( ()=>{
              tooltip.transition()
              .duration(200)
              .style('opacity',0)
            }, 5000);
          });
      }
    })

  }

  // add some methods for the chart to be updated
  chart.size = function(value){
    if(!arguments.length) return size
    size = value
    return chart
  }

  chart.data = function(value){
    if(!arguments.length) return data
    data = value
    return chart
  }

  chart.title = function(value){
    if(!arguments.length) return title
    title = value
    return chart
  }

  chart.draw = function(){
    if(typeof drawChart === 'function') drawChart()
  }

  return chart
}

export default scatterPlot



// WEBPACK FOOTER //
// ./src/utils/scatterPlot.js